export default {
  back: {
    en: 'Back',
    ar: 'عودة'
  },
  next: {
    en: 'Next',
    ar: 'التالي'
  }
};
